import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import BatteryForm from './BatteryForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission, parseURL } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "./store/batteryActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const BatteryEdit = props => {
    const { battery, loading, classes, onFetchBatteryInit, activeCustomer, translations, permissions } = props;
    const [data, setData] = useState(true);
    let searchParams = parseURL(window.location.search);

    const handleSubmit = async data => {
        data['ComponentID'] = battery.ComponentID;
        data['ComponentType'] = 'battery';
        data['ProductID'] = searchParams.productID;

        let result = await props.onEditBattery({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack()
        }
    }
    useEffect(() => {
        const fetchData = async () => {
            await props.onFetchBattery({ ActiveCustomerID: activeCustomer, ComponentID: parseURL(window.location.href).ComponentID })
            setData(false)
        }
        fetchData();
        return () => {
            onFetchBatteryInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let initialValues = {
        ComponentType: "battery",
        Vendor: battery.Vendor || "",
        ComponentModel: battery.ComponentModel || '',
        SerialNumber: battery.SerialNumber || '',
        BatteryHealth: battery && battery.BatteryComponents && battery.BatteryComponents.length > 0 ? battery.BatteryComponents[0].BatteryHealth : '',
        BatteryCycleCount: battery && battery.BatteryComponents && battery.BatteryComponents.length > 0 ? battery.BatteryComponents[0].BatteryCycleCount : 0,
        BatteryDesignCapacity: battery && battery.BatteryComponents && battery.BatteryComponents.length > 0 ? battery.BatteryComponents[0].BatteryDesignCapacity : 0,
        BatteryFullChargeCapacity: battery && battery.BatteryComponents && battery.BatteryComponents.length > 0 ? battery.BatteryComponents[0].BatteryFullChargeCapacity : 0,
        Description: battery.Description || ''
    };
    let formSettings = {
        Validation: {
            ComponentType: Yup.string().required("Required"),
            Vendor: Yup.string().required("Required"),
            ComponentModel: Yup.string().required("Required"),
            SerialNumber: Yup.string().required("Required"),
            BatteryHealth: Yup.string().required("Required"),
            BatteryCycleCount: Yup.number().required("Required"),
            BatteryDesignCapacity: Yup.number().required("Required"),
            BatteryFullChargeCapacity: Yup.number().required("Required"),
        },
        FormTitle: translations['edit_battery_component'] || "Edit battery component",
        ButtonSubmit: searchParams.editable === '1' && hasPermission(permissions, "component_save")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
    };

    return (
        <Paper className={classes.root} >
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }} >

                <AppLogoLoading />
            </Dialog>
            {!data ?
                <BatteryForm
    formSettings={formSettings}
    initialValues={initialValues}
    handleSubmit={handleSubmit}
    loading={loading}
    translations={translations}
    />
                : <CircularProgress
                    variant="determinate"
                    color="primary"
                    size={28}
                />}
        </Paper>)
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        battery: state.product.batteries.loaded ? state.product.batteries.loaded : {},
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchBatteryInit: battery => dispatch(actions.loadBatteryInit(battery)),
        onFetchBattery: battery => dispatch(actions.loadBattery(battery)),
        onEditBattery: battery => dispatch(actions.editBattery(battery)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(BatteryEdit));
